"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./aboutMe.scss");
var biruk_pic_jpg_1 = __importDefault(require("../../../Assets/img/biruk_pic.jpg"));
var AboutMe = /** @class */ (function (_super) {
    __extends(AboutMe, _super);
    function AboutMe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AboutMe.prototype.render = function () {
        return (react_1.default.createElement("div", { className: 'about-landing-container' },
            react_1.default.createElement("div", { className: 'about-container' },
                react_1.default.createElement("div", { className: 'about-header', id: 'about_me' },
                    react_1.default.createElement("div", { "data-aos": "slide-left", className: 'about-pic', style: {
                            backgroundImage: "url(" + biruk_pic_jpg_1.default + ")"
                        } }),
                    react_1.default.createElement("div", { "data-aos": "zoom-in", className: 'about-title' },
                        react_1.default.createElement("h2", null, "About me"))),
                react_1.default.createElement("div", { className: 'about-desc', "data-aos": "zoom-in" },
                    react_1.default.createElement("p", null, "My name is Biruk, I\u2019m a computer science graduate from a local university, and cofounder of kelal tech startup, I live in Addis but I call many places home. im passionate about helping my community and solving problems that can change the world, I believe together we can make a difference.")),
                react_1.default.createElement("div", { className: 'contact', "data-aos": "zoom-in" },
                    react_1.default.createElement("button", null,
                        react_1.default.createElement("a", { title: 'lets talk about the project', target: '_blank', href: 'http://www.biruktesfayeve@gmail.com' }, "Get Connected"))))));
    };
    return AboutMe;
}(react_1.Component));
exports.AboutMe = AboutMe;



//////////////////
// WEBPACK FOOTER
// ./src/App/components/AboutMe/AboutMe.tsx
// module id = 65
// module chunks = 0